<template>
  <section id="section-about" class="section bg">
    <div class="flex-column section-content d-flex">
      <div class="section-title-container d-flex">
        <a style="align-self: center">关于我们</a>
      </div>
      <div class="d-flex flex-lg-row-reverse flex-column">
        <div class="flex-column about-intro" style="flex: 0.5">
          <p>　　建个会隶属于杭州移木科技有限公司，致力于推动民间做会的线上化，阳光化。公司成立于2018年3月，2018年6月完成千万级的天使轮融资。</p>
          <div class="text-nowrap">联系电话：<a href="tel:17706035991">17706035991</a></div>
          <div>公司地址：福州市仓山区万达广场C3号楼9层</div>
        </div>
        <div class="about-intro-img"><img src="../assets/img_about.png"/></div>
      </div>
    </div>
    <div class="bottom-copyright">@2018 杭州移木科技有限公司<span style="margin-left: 10px">浙ICP证B2-20180895</span></div>
  </section>
</template>

<script>export default {name: "SectionAboutUs"}</script>
<style scoped>
  @media (max-width: 992px) {
    .bottom-copyright {
      font-size: 12px;
      color: #999;
    }

    .about-intro > p {
      text-align: justify;
      margin: 40px 0 20px 0;
    }

    .about-intro {
      align-self: center;
      font-size: 14px;
      color: #333;
      text-align: left;
      line-height: 2em;
      margin: 0 40px;
    }

    .about-intro-img {
      margin: 20px;
    }
  }

  @media (min-width: 992px) {
    .bottom-copyright {
      align-self: center;
      font-size: 14px;
      color: #999;
      padding: 60px;
    }

    .about-intro {
      align-self: center;
      font-size: 18px;
      color: #333;
      text-align: left;
      line-height: 2em;
      margin-left: 20px;
    }

    .about-intro > p {
      text-align: justify;
      margin-bottom: 60px;
    }

    .about-intro-img {
      flex: 0.5;
    }

    .bg {
      background: url("../assets/bg_about_right.png") no-repeat right bottom;
      background-size: auto 100%;
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/SectionAboutUs.vue